// Utility helpers — Indian formatting.

export function inr(value, { compact = false } = {}) {
  const num = Number(value || 0);
  if (!isFinite(num)) return "₹0";
  if (compact) {
    if (Math.abs(num) >= 1_00_00_000) return `₹${(num / 1_00_00_000).toFixed(2)} Cr`;
    if (Math.abs(num) >= 1_00_000) return `₹${(num / 1_00_000).toFixed(2)} L`;
    if (Math.abs(num) >= 1_000) return `₹${(num / 1_000).toFixed(1)}K`;
  }
  return `₹${num.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
}

export function inrFull(value) {
  return `₹${Number(value || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
}

export function fmtDate(iso) {
  if (!iso) return "-";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yy = d.getFullYear();
  return `${dd}-${mm}-${yy}`;
}

export const STATUS_STYLES = {
  available: "bg-emerald-100 text-emerald-800 border-emerald-300",
  reserved: "bg-amber-100 text-amber-800 border-amber-300",
  booked: "bg-blue-100 text-blue-800 border-blue-300",
  agreement_done: "bg-indigo-100 text-indigo-800 border-indigo-300",
  registered: "bg-purple-100 text-purple-800 border-purple-300",
  sold: "bg-zinc-200 text-zinc-700 border-zinc-400",
  cancelled: "bg-red-100 text-red-700 border-red-300",
  blocked: "bg-rose-100 text-rose-800 border-rose-300",
};

export const STATUS_LABEL = {
  available: "Available",
  reserved: "Reserved",
  booked: "Booked",
  agreement_done: "Agreement",
  registered: "Registered",
  sold: "Sold",
  cancelled: "Cancelled",
  blocked: "Blocked",
};

export const LEAD_STATUSES = [
  { key: "new", label: "New" },
  { key: "contacted", label: "Contacted" },
  { key: "site_visit", label: "Site Visit" },
  { key: "quotation", label: "Quotation" },
  { key: "negotiation", label: "Negotiation" },
  { key: "booked", label: "Booked" },
  { key: "lost", label: "Lost" },
];
